import { environment as env } from '../../../../../environments/environment';


const BASE_API_URL = env.ApiUrl + 'api/'; // env.apiGateWayAdmin;

export const SAT_REPORT_ENDPOINTS = {
  list: `${BASE_API_URL}reporting/sat/list`,
  error_list: `${BASE_API_URL}reporting/campaign/{id}/errors`
};


